import React from "react";
import { Button } from "primereact/button";
import ModalBase from "./ModalBase";
import PropTypes from "prop-types";

// Specialized modal for simple interactions
const SimpleModal = ({
  children,
  title,
  visible,
  onHide,
  onConfirm,
  confirmLabel = "Confirmar",
  confirmIcon = "pi pi-check",
  showCancel = true,
  cancelLabel = "Cancelar",
  isLoading = false,
  size = "small",
  variant = "simple",
  closable = true,
  className = "",
  footer: footerProp,
  onBeforeHide,
  ...props
}) => {
  const defaultFooter = (
    <div className="modal-footer">
      {showCancel && (
        <Button
          label={cancelLabel}
          icon="pi pi-times"
          onClick={onHide}
          className="p-button-text p-button-sm"
          disabled={isLoading}
          data-evo-id="simplemodal-btn-cancel"
        />
      )}
      <Button
        label={confirmLabel}
        icon={confirmIcon}
        onClick={onConfirm}
        className="p-button-success p-button-sm"
        disabled={isLoading}
        autoFocus={!showCancel}
        data-evo-id="simplemodal-btn-confirm"
      />
    </div>
  );

  const resolvedFooter = footerProp !== undefined ? footerProp : defaultFooter;

  return (
    <ModalBase
      header={title}
      visible={visible}
      onHide={onHide}
      footer={resolvedFooter}
      size={size}
      variant={variant}
      className={`${isLoading ? "modal-loading" : ""} ${className}`.trim()}
      closable={closable}
      onBeforeHide={onBeforeHide}
      {...props}
    >
      {children}
    </ModalBase>
  );
};

SimpleModal.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  visible: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onConfirm: PropTypes.func,
  confirmLabel: PropTypes.string,
  confirmIcon: PropTypes.string,
  showCancel: PropTypes.bool,
  cancelLabel: PropTypes.string,
  isLoading: PropTypes.bool,
  size: PropTypes.oneOf(["tiny", "small", "medium", "large", "full"]),
  variant: PropTypes.oneOf(["form", "data", "simple", "warning"]),
  closable: PropTypes.bool,
  onBeforeHide: PropTypes.func,
};

export default SimpleModal;
